// Shared field definitions / helpers for the user drawer.
//
// Used by useUserDrawerData (drawer) and may be reused elsewhere if a
// user form ever needs the same admin payload contract.

export const USER_PUT_FIELDS = [
  "first_name",
  "last_name",
  "middle_name",
  "email",
  "phone",
  "is_active",
  "role_codes",
  "organization_id",
];

export const USER_POST_FIELDS = [...USER_PUT_FIELDS, "identifier", "password"];

export function clone(v) {
  return JSON.parse(JSON.stringify(v ?? {}));
}

export function pickFields(data, fields) {
  const out = {};
  for (const k of fields) {
    if (data[k] !== undefined) out[k] = data[k];
  }
  return out;
}

/**
 * Some endpoints return `role_codes`, others return a richer `roles`
 * array with role objects. Normalize so `role_codes` is always populated.
 */
export function normalizeRoles(payload) {
  if (Array.isArray(payload?.role_codes) && payload.role_codes.length) {
    return payload;
  }
  const roles = Array.isArray(payload?.roles) ? payload.roles : [];
  return {
    ...(payload || {}),
    role_codes: roles.map((r) => r?.code).filter(Boolean),
  };
}

export function emptyUserData() {
  return {
    identifier: "",
    first_name: "",
    last_name: "",
    middle_name: "",
    email: "",
    phone: "",
    is_active: true,
    organization_id: null,
    role_codes: [],
    roles: [],
    permissions: [],
  };
}
